import { jsxs, jsx } from 'react/jsx-runtime';
import { ArrowAngleRight } from '@zooplus/icons';
import GiftIcon from '../../images/gift-enhanced.js';
import styles from './FreeSamples.module.scss.js';

/**
 * Render a component that displays a gift box image along with some text
 * and a right-angle icon. The text is localized with the given translation
 * function. The component takes a single object parameter with the following
 * properties:
 *
 * @param {FreeSamplesProps} props - An object containing the following:
 *   @param {Function} props.t - The translation function to use for localizing
 *                                the text in the component.
 *
 * @return {JSX.Element} A JSX element representing the component.
 */
function FreeSamples({ t, handler }) {
    return (jsxs("div", { className: styles.freeSamplesGrid, onClick: handler, children: [jsx("div", { className: styles.wrapperGiftIcon, children: jsx(GiftIcon, {}) }), jsxs("div", { className: styles.wrapperContent, children: [jsx("div", { className: styles.freeSamplesCaption, children: t('samples.free.title') }), jsxs("div", { className: styles.wrapperDescription, children: [jsx("div", { className: styles.description, children: t('samples.free.mainText') }), jsxs("div", { className: styles.wrapperLink, children: [jsx("div", { className: styles.textLink, children: t('samples.free.selectSample') }), jsx(ArrowAngleRight, { className: styles.iconLink })] })] })] })] }));
}

export { FreeSamples };
//# sourceMappingURL=FreeSamples.js.map
